(function () {
    'use strict';

    angular
        .module('advancedapp')
        .controller('ResourcesPageController', ResourcesPageController);

    ResourcesPageController.$inject = ['$location', '$scope', 'search_service'];

    function ResourcesPageController($location, $scope, search_service) {
        /* jshint validthis:true */
        var ctrl = this;
        ctrl.title = 'ResourcesPageController';

        ctrl.init = init;
        ctrl.onCategoryChange = onCategoryChange;
        ctrl.search = search;
        ctrl.sort = sort;
        ctrl.toggleView = toggleView;
        ctrl.gridView = false;

        ctrl.sortOptions = [{ value: 1, text: 'Date: Newest to Oldest' }, { value: 2, text: 'Date: Oldest to Newest' }, { value: 3, text: 'A:Z' }];

        ctrl.searchUrl = "";

        ctrl.criteria = {
            categories: [],
            searchTerm: "",
            sortBy: 0,
            rootPageId: 0
        };

        function onCategoryChange(model) {
            ctrl.criteria = model;
            searchWithCats(ctrl.criteria);
        }


        function init(data, url, rootPageId) {
            
            ctrl.results = data;
            ctrl.searchUrl = url.url;
            ctrl.criteria.rootPageId = rootPageId;
        }


        function search() {
         
            searchWithCats(ctrl.criteria)
                .then(function (result) {

                    return result;
                });
        }

        function searchWithCats(model) {

            var searchUrl = ctrl.searchUrl + 'search/';

            return search_service.search(searchUrl, model)
                .then(function (result) {
              
                    ctrl.results = result;

                    return result;
                });
        }

        function sort(value) {

            ctrl.criteria.sortBy = value;

            searchWithCats(ctrl.criteria);

        }

        function toggleView(value) {

            if (value == 'grid') {

                ctrl.gridView = true;
            }
            else {
                ctrl.gridView = false;
            }

        }

    }
})();
